<template>
  <van-popup v-if="changePersonPopupShow " :value="changePersonPopupShow" z-index="100" :close-on-click-overlay="false"
                   :style="{ height: '100vh',width: '100vw', background: 'rgba(0,0,0,.3)' }" overlay-class="custom_popup" position="right">
      <div class="project_record_wrap" ref="recordDialog">
          <div class="project_record_top">
              <div class="returnNavBar">
                  <div class="returnNavBarLeft" @click="handleClickClose">
                      <van-icon  name="arrow-left" />
                      <span class="normal_title">返回</span>
                  </div>
              </div>
          </div>

          <div class="project_record_bottom">
              <van-form colon ref="formData" scroll-to-error>
                  <ul>
                      <li>
                          <van-field :rules="changePersonFormRules.head_uid" @click="handleClickHeadUser" input-align="right" label="项目负责人" is-link readonly placeholder="请选择" required  v-model="changePersonForm.head_uid_text"></van-field>
                      </li>
                  </ul>
              </van-form>
          </div>

          <div class="project_record_footer_wrap">
              <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
          </div>

          <!-- 人员选择 -->
          <UserSearchSelect :userSelectVisible.sync="userSelectVisible"  :userSelectTitle="'选择人员'" :selectType="'one'" @selectUserData="handleSelectUserData" v-if="userSelectVisible"/>
      </div>
    </van-popup>
</template>
<script>
    import {ProjectHeadUidEdit} from "@/api";
    import UserSearchSelect from "@/components/mComponents/UserSearchSelect.vue";
    export default {
        components: {UserSearchSelect},
        name: "ProjectAddMember",
        props: {
            changePersonPopupShow: {
                type: Boolean,
                default: false,
            },
            projectId: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                changePersonForm: {
                    head_uid: '',
                    head_uid_text:''
                },
                changePersonFormRules: {
                    head_uid: [
                        {required: true, message: '请选择人员', trigger: 'onChange'}
                    ]
                },
                btnDisabled:false,
                userSelectVisible: false,
            }
        },
        created() {

        },
        methods: {
            // 关闭弹窗
            handleClickClose() {
                this.$emit('update:changePersonPopupShow', false)
            },

            // 选择项目负责人
            handleClickHeadUser(){
                this.userSelectVisible = true
            },
            // 选择人员回调
            handleSelectUserData(data){
                this.$set(this.changePersonForm,'head_uid',data.uid)
                this.$set(this.changePersonForm,'head_uid_text',data.name)
            },

            // 确定
            handleClickConfirm() {
                this.$refs.formData.validate().then(() => {
                    this.btnDisabled = true
                    ProjectHeadUidEdit({
                        id: this.projectId,
                        head_uid:this.changePersonForm.head_uid
                    }).then(res => {
                        if (res.code === 200) {
                            this.$toast({
                                message:'更换成功',
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.btnDisabled = false
                                    this.$emit('update:changePersonPopupShow', false)
                                    this.$emit('success')
                                },
                            });
                        }
                        this.btnDisabled = false
                    })
                })

            },
        },
    }
</script>
<style lang="scss" scoped>
@import "@/styles/m_style/project_management.scss";
</style>